export const getCountryConfig = (countryCode) => {
  const code = (countryCode || "IN").toUpperCase();
  
  const configs = {
    IN: {
      code: "IN",
      currencySymbol: "₹",
      salaryFormat: "indian",
      phoneCode: "+91",
    },
    AU: {
      code: "AU",
      currencySymbol: "A$",
      salaryFormat: "standard",
      phoneCode: "+61",
    },
    US: {
      code: "US",
      currencySymbol: "$",
      salaryFormat: "standard",
      phoneCode: "+1",
    },
    GB: {
      code: "GB",
      currencySymbol: "£",
      salaryFormat: "standard",
      phoneCode: "+44",
    },
    CA: {
      code: "CA",
      currencySymbol: "C$",
      salaryFormat: "standard",
      phoneCode: "+1",
    },
    SG: {
      code: "SG",
      currencySymbol: "S$",
      salaryFormat: "standard",
      phoneCode: "+65",
    },
    MY: {
      code: "MY",
      currencySymbol: "RM",
      salaryFormat: "standard",
      phoneCode: "+60",
    },
    PH: {
      code: "PH",
      currencySymbol: "₱",
      salaryFormat: "standard",
      phoneCode: "+63",
    },
    AE: {
      code: "AE",
      currencySymbol: "AED",
      salaryFormat: "standard",
      phoneCode: "+971",
    },
  };

  return configs[code] || configs["IN"];
};

export const formatSalary = (amount, countryCode) => {
  if (!amount && amount !== 0) return "-";
  
  // Convert to string and remove all non-numeric characters (except dot if decimals allowed, but here assuming integer salary)
  const cleanAmount = String(amount).replace(/[^0-9]/g, "");
  
  // Ensure it's a number
  const num = parseInt(cleanAmount, 10);
  if (isNaN(num)) return amount; // return raw if not a number

  const config = getCountryConfig(countryCode);

  if (config.salaryFormat === "indian") {
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 0,
    }).format(num);
  }

  // Standard (US/AU/UK) - e.g. 123,456
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
  }).format(num);
};

export const getCurrencySymbol = (countryCode) => {
  return getCountryConfig(countryCode).currencySymbol;
};

export const getPDFCurrencySymbol = (countryCode) => {
  return getCountryConfig(countryCode).currencySymbol;
};

export const getPhoneCode = (countryCode) => {
  return getCountryConfig(countryCode).phoneCode;
};
